<script setup lang="ts">
import type { ComparisonRow } from '../data/content'
withDefaults(defineProps<{ rows: ComparisonRow[]; lang?: 'pl' | 'en' }>(), { lang: 'pl' })
</script>

<template>
  <div class="comparison-wrap">
    <table class="comparison-table">
      <thead><tr><th scope="col">{{ lang === 'en' ? 'Approach' : 'Podejście' }}</th><th scope="col">{{ lang === 'en' ? 'Environment' : 'Środowisko' }}</th><th scope="col">{{ lang === 'en' ? 'Curriculum control' : 'Kontrola programu' }}</th><th scope="col">{{ lang === 'en' ? 'Natural use case' : 'Naturalne zastosowanie' }}</th></tr></thead>
      <tbody>
        <tr v-for="row in rows" :key="row.product" :class="{ 'is-pentestcamp': row.product === 'PentestCamp' }">
          <th scope="row">
            <a v-if="row.source" :href="row.source" target="_blank" rel="noreferrer">{{ row.product }}</a><span v-else>{{ row.product }}</span>
            <small>{{ row.mode }}</small>
          </th>
          <td :data-label="lang === 'en' ? 'Environment' : 'Środowisko'">{{ row.environment }}</td><td :data-label="lang === 'en' ? 'Curriculum control' : 'Kontrola programu'">{{ row.courseControl }}</td><td :data-label="lang === 'en' ? 'Natural use case' : 'Naturalne zastosowanie'">{{ row.fit }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
